import Vue from 'vue';
let Dialog = Vue.extend(require('./dialog.vue').default);
import {store} from '../main'

Vue.prototype.$dialog = function (type, param) {
    let instance = new Dialog({
        data: {
            type: type,
            param: param,
            visible: false,
            titles: {
                client_add: 'Добавление клиента',
                client_search: 'Поиск клиентов',
                partner_add: 'Добавление партнера',
                partner_search: 'Поиск партнеров',
                partnerLegal_search: 'Поиск юр. лиц',
                contragent_add: 'Добавление контрагента',
                contragent_search: 'Поиск контрагентов',
                regular_search: 'Поиск плановых платежей',
                invoices_search: 'Поиск счетов',
                reports: 'Создание отчета',
                cash_add: 'Создание кассы',
                payment_account_add: 'Создание счёта',
            }
        },
        store,
    });
    setTimeout(()=>{
        instance.visible= true;
    });
    instance.close = function () {
        if(typeof param.close === 'function'){
            param.close();
        }
        instance.visible = false;
        setTimeout(()=>{
            instance.$destroy();
        },300)
    };
    instance.change = function (val) {
        if(typeof param.change === 'function'){
            param.change(val);
        }
        instance.visible = false;
        setTimeout(()=>{
            instance.$destroy();
        },300)
    };
    instance.destroyed = ()=>{
        setTimeout(()=>{
            document.body.removeChild(instance.$el);
        },300)

    };
    document.body.appendChild(instance.$mount().$el);

    return instance;
};
